import gatewayService from '@/modules/common/services/gatewayService';

const leadsWidgetRoute = '/v3/clients/reports/leads_widget';
const aiReceptionistMetricsRoute = '/v3/online_presence/ai_receptionist/metrics';

const getLeadsWidgetData = (period = 'year', chartPeriod = 'month') => gatewayService
  .get(leadsWidgetRoute, { period, chart_period: chartPeriod })
  .then((response) => response.data);

const getAiReceptionistMetrics = (period = 'year') => gatewayService
  .get(aiReceptionistMetricsRoute, { period })
  .then((response) => response.data);

export default {
  getAiReceptionistMetrics,
  getLeadsWidgetData,
};
